import * as S from "./PointContent.style";

interface PointContentProps {
  userData?: any;
  children?: React.ReactNode;
}

export const PointContent = ({ userData, children }: PointContentProps) => {
  return (
    <S.PointContent>
      <S.PointInfoBox>
        <S.PointInfo>
          <span>{userData?.userName} 님의 건강 포인트</span>
          <S.Point>
            {userData?.currentPoint} <span>POINT</span>
          </S.Point>
        </S.PointInfo>

        {/* 포인트 적립유형별 표기 할 경우 추가 */}
        <S.PointFilterBox>
          <S.PointFilterItem>
            <span>총 출석 일수</span>
            {userData.attend_day}일
          </S.PointFilterItem>
          <S.PointFilterItem>
            <span>운동 프로그램 참여</span>
            {userData.exercise_day}회
          </S.PointFilterItem>
          <S.PointFilterItem>
            <span>기타</span>
            {userData.etc}회
          </S.PointFilterItem>
        </S.PointFilterBox>
      </S.PointInfoBox>

      <S.PointHistoryBox>{children}</S.PointHistoryBox>
    </S.PointContent>
  );
};
